<glxy-form-field [disabled]="control?.disabled">
  <glxy-label>{{ placeholder }}</glxy-label>
  <textarea
    cdkTextareaAutosize
    [placeholder]="placeholder"
    *ngIf="(isLoading$$.asObservable() | async) === false"
    [formControl]="control"
    [required]="required"
  ></textarea>
  <glxy-hint *ngIf="tooltip" align="start" [matTooltip]="tooltip">
    <a (click)="(null)" class="link">
      {{ 'FRONTEND.FORMS.INPUT.WHATS_THIS' | translate }}
    </a>
  </glxy-hint>
  <glxy-hint
    align="end"
    *ngIf="maxLength"
    [ngStyle]="{
      color: (control.value || '').length > maxLength ? 'red' : null
    }"
  >
    {{ (control.value || '').length }}/{{ maxLength }}
  </glxy-hint>
  <mat-error *ngIf="errorOutput(control)">{{ errorOutput(control) }}</mat-error>
  <glxy-loading-spinner *ngIf="(isLoading$$.asObservable() | async) === true"></glxy-loading-spinner>
  <glxy-ai-text-button
    [disabled]="control?.disabled"
    [fieldName]="fieldName"
    [value]="control.value"
    (suggest)="getSuggestion()"
    (update)="suggestUpdate($event)"
  ></glxy-ai-text-button>
</glxy-form-field>
